
/* Falaq WhatsApp router (13 Oct 2026): every WhatsApp link on the site goes to one of the
   store numbers instead of the owner's number. Each visitor gets one store at random and keeps
   it for the day, so all stores share the messages. The message says clearly that the customer
   is writing from the website, with the piece, option, price and link on product pages.
   20 Oct 2026: Qurum (Ahad Jewelry) removed by the owner; Falaq stores only. */
(function () {
  var STORES = [
    { name: 'Mawaleh', phone: '96893555266' },
    { name: 'Sohar', phone: '96899185515' },
    { name: 'Khaburah', phone: '96893322772' }
  ];
  var OWNER = '95832063';
  function today() {
    var d = new Date(Date.now() + (new Date().getTimezoneOffset() + 240) * 60000);
    return d.toISOString().slice(0, 10);
  }
  function pickStore() {
    var key = 'falaq_wa_store', t = today(), v;
    try { v = JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { v = null; }
    if (v && v.d === t && STORES[v.i]) return STORES[v.i];
    var i = Math.floor(Math.random() * STORES.length);
    try { localStorage.setItem(key, JSON.stringify({ d: t, i: i })); } catch (e) {}
    return STORES[i];
  }
  function isOwnerLink(a) {
    var h = (a.getAttribute('href') || '').replace(/[^0-9a-z.:\/]/gi, '');
    return /wa\.me|whatsapp\.com/i.test(h) && h.indexOf(OWNER) > -1;
  }
  function selectedOptions(box) {
    var scope = document.querySelector('product-info, .product__info-container, main') || document;
    var vals = [];
    scope.querySelectorAll('input[type=radio]:checked').forEach(function (r) {
      if (r.name && !/^FalaqUS/.test(r.id) && r.value) vals.push(r.value);
    });
    if (!vals.length) {
      scope.querySelectorAll('select').forEach(function (s) {
        if (!s.closest('[data-falaq-sizehelp]') && s.value && s.name && s.name.indexOf('options') > -1) vals.push(s.value);
      });
    }
    return vals.join(' / ');
  }
  var product = null;
  if (/\/products\/[^\/]+\/?$/.test(location.pathname)) {
    fetch(location.pathname.replace(/\/$/, '') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { product = p; })
      .catch(function () {});
  }
  function money(v) { return (v / 100).toFixed(3); }
  function message(a) {
    var ar = (document.documentElement.lang || '').indexOf('ar') === 0;
    var d = {};
    if (product) {
      d.waTitle = product.title;
      var idEl = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var vid = idEl ? String(idEl.value) : '';
      var v = (product.variants || []).filter(function (x) { return String(x.id) === vid; })[0] || (product.variants || [])[0];
      if (v) d.waPrice = money(v.price);
    }
    var url = location.origin + location.pathname;
    var lines;
    if (d.waTitle) {
      var opts = selectedOptions();
      var price = d.waPrice || '';
      lines = ar ? [
        '*استفسار من الموقع الإلكتروني* – falaqjewelry.com',
        '',
        'القطعة: ' + d.waTitle,
        opts ? 'الخيار: ' + opts : null,
        price ? 'السعر: ' + price + ' ر.ع' : null,
        'الرابط: ' + url,
        '',
        'السلام عليكم، أودّ الاستفسار عن هذه القطعة.'
      ] : [
        '*Website enquiry* – falaqjewelry.com',
        '',
        'Piece: ' + d.waTitle,
        opts ? 'Option: ' + opts : null,
        price ? 'Price: ' + price + ' OMR' : null,
        'Link: ' + url,
        '',
        'Hello, I would like to ask about this piece.'
      ];
    } else {
      lines = ar ? [
        '*استفسار من الموقع الإلكتروني* – falaqjewelry.com',
        '',
        'الصفحة: ' + url,
        '',
        'السلام عليكم، عندي استفسار.'
      ] : [
        '*Website enquiry* – falaqjewelry.com',
        '',
        'Page: ' + url,
        '',
        'Hello, I have a question.'
      ];
    }
    return lines.filter(function (l) { return l !== null; }).join('\n');
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !isOwnerLink(a)) return;
    var store = pickStore();
    a.href = 'https://wa.me/' + store.phone + '?text=' + encodeURIComponent(message(a));
  }, true);
})();
